import(/* webpackMode: "eager", webpackExports: ["Architecture"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Architecture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Benefits"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Benefits.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTA"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Features"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher","LanguageSwitcherCompact","LanguageSwitcherIcon"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoCloud"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/LogoCloud.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pricing"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/workspace/swishr-pulse-v-119f21a/src/features/landing/Testimonials.tsx");
